import React from 'react';
import { X } from 'lucide-react';
import './GroupTimelineFocusBanner.css';

export interface GroupTimelineFocusOption {
  id: string;
  label: string;
}

interface GroupTimelineFocusBannerProps {
  extraTasks: Array<GroupTimelineFocusOption>;
  onRemove: (taskId: string) => void;
}

const GroupTimelineFocusBanner: React.FC<GroupTimelineFocusBannerProps> = ({
  extraTasks,
  onRemove,
}) => {
  return (
    <div className="pm-hub-focus-banner">
      <ul className="pm-hub-focus-chips" aria-label="Added timeline tasks">
        {extraTasks.map((opt) => (
          <li key={opt.id}>
            <span>{opt.label}</span>
            <button
              type="button"
              className="pm-hub-focus-chip-remove"
              aria-label={`Remove ${opt.label}`}
              onClick={() => onRemove(opt.id)}
            >
              <X size={11} strokeWidth={2.4} aria-hidden />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GroupTimelineFocusBanner;
